/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Hof_DescriptionInputs */



/**
* | output |
* | --- |
* | "Five or more tournament wins. A win counts if the event had 10+ players in person and the winning decklist is on record." |
*
* @param {Hof_DescriptionInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const hof_description = /** @type {((inputs?: Hof_DescriptionInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Hof_DescriptionInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Au moins cinq victoires en tournoi. Une victoire compte si le tournoi a réuni 10 joueurs ou plus en présentiel et que la decklist gagnante est archivée.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Cinco o más victorias en torneo. Una victoria cuenta si el torneo fue presencial con 10 jugadores o más y la decklist ganadora está archivada.")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Cinco ou mais vitórias em torneio. Uma vitória conta se o torneio foi presencial com 10 jogadores ou mais e a decklist vencedora está arquivada.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Cinque o più vittorie in torneo. Una vittoria conta se il torneo era in presenza con almeno 10 giocatori e la decklist vincente è archiviata.")
	return /** @type {LocalizedString} */ ("Five or more tournament wins. A win counts if the event had 10+ players in person and the winning decklist is on record.")
});